export enum RegistrationErrorStatus {
  BadRequest = 'BAD_REQUEST',
  InternalError = 'INTERNAL_ERROR',
}
